import React, { useCallback, useState } from 'react'
import { useQuery } from '@tanstack/react-query'

import type { NutsRegion } from '@/api/types'
import { fetchNuts } from '@/api'
import { Select } from '@/components/Select'

type Props = {
  value?: NutsRegion
  isDisabled?: boolean
  onChange(region: NutsRegion): void
}

export default function NutsSelect({ value, isDisabled, onChange }: Props) {
  const [enabled, setEnabled] = useState(false)
  const { data, isLoading } = useQuery({
    queryKey: ['nuts'],
    queryFn: fetchNuts,
    enabled,
    select: useCallback((data: NutsRegion[]) => {
      const groups = data.filter((item) => item.level === 0)

      const d = groups.map((group) => ({
        label: group.name,
        options: data.filter((item) => {
          if (item.code.startsWith(group.code)) {
            return true
          }

          return false
        }),
      }))
      return d
    }, []),
  })

  return (
    <Select
      isDisabled={isDisabled}
      options={data}
      value={value}
      getOptionLabel={formatString}
      getOptionValue={(item) => item.code}
      isLoading={isLoading}
      onFocus={() => setEnabled(true)}
      onChange={onChange}
    />
  )
}

const formatString = (region: NutsRegion) => {
  const indentation = region.level === 2 ? '--' : ''

  return `${indentation} ${region.name} (L${region.level})`
}
